import { HorizontalContainer } from '@american-autonomy/ag-ui';

import ToggleButton from 'components/buttons/ToggleButton';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Toggle: FunctionComponent<Props> = ({
    activeIndex,
    className = '',
    onClick,
    options,
    testId = TEST_ID
}) => (
    <HorizontalContainer className={className} testId={testId}>
        <div
            style={
                {
                    '--active-index': activeIndex,
                    '--option-count': options.length
                } as React.CSSProperties
            }
            className={styles.grid}>
            <HorizontalContainer className={styles.slider} />

            <HorizontalContainer className={styles.buttons}>
                {options.map(({ label, value }, index) => (
                    <ToggleButton
                        className={styles.toggleButton}
                        key={`${value}-${index}`}
                        onClick={() => onClick(value)}
                        text={label}
                    />
                ))}
            </HorizontalContainer>
        </div>
    </HorizontalContainer>
);

export default Toggle;
